import React from 'react';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { TruthSection } from './components/TruthSection';
import { FourMaps } from './components/FourMaps';
import { WhyOldFails } from './components/WhyOldFails';
import { WhatsIncluded } from './components/WhatsIncluded';
import { HowToUse } from './components/HowToUse';
import { PricingSection } from './components/PricingSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
export function App() {
  return <div className="min-h-screen font-sans text-gray-900 bg-white selection:bg-teal-100 selection:text-teal-900" data-id="element-0">
      <HeroSection data-id="element-1" />
      <PainPoints data-id="element-2" />
      <TruthSection data-id="element-3" />
      <FourMaps data-id="element-4" />
      <WhyOldFails data-id="element-5" />
      <WhatsIncluded data-id="element-6" />
      <HowToUse data-id="element-7" />
      <PricingSection data-id="element-8" />
      <FAQ data-id="element-9" />
      <FinalCTA data-id="element-10" />

      {/* Footer */}
      <footer className="bg-navy-900 text-gray-400 py-12 text-center text-sm" data-id="element-11">
        <div className="container mx-auto px-4" data-id="element-12">
          <p data-id="element-13">
            &copy; {new Date().getFullYear()} The NDIS Autism Plan Builder. All
            rights reserved.
          </p>
          <p className="mt-2" data-id="element-14">Not affiliated with the NDIS.</p>
        </div>
      </footer>
    </div>;
}